'use client';

import { merge } from 'lodash-es';
import { useContext, useLayoutEffect } from 'react';
import { StoreContext, type StoreProviderProps } from './StoreProvider.tsx';

export const StoreUpdateProvider = ({ children, initialState }: Required<StoreProviderProps>) => {
  const storeContext = useContext(StoreContext);

  if (!storeContext) {
    throw new Error(`StoreUpdateProvider must be used within StoreProvider`);
  }

  useLayoutEffect(() => {
    const currentState = storeContext.getState();
    storeContext.setState(merge(currentState, initialState), true);
    // We only want to re-execute on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return children;
};
